import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export const ErrorBoundary = () => {
  const error = useRouteError();

  let errorMessage: string;
  let errorStatus: string;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message || 'An error occurred';
    errorStatus = error.status.toString();
  } else if (error instanceof Error) {
    errorMessage = error.message;
    errorStatus = 'Error';
  } else {
    errorMessage = 'Unknown error';
    errorStatus = 'Error';
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md space-y-8 rounded-lg bg-white p-8 shadow-lg dark:bg-gray-800">
        <div className="text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/20">
            <svg
              className="h-6 w-6 text-red-600 dark:text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h1 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">
            {errorStatus}
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">{errorMessage}</p>
        </div>

        <div className="flex flex-col space-y-3">
          <Button onClick={() => (window.location.href = '/client/')} variant="primary">
            Go to Dashboard
          </Button>
          <Button onClick={() => window.history.back()} variant="outline">
            Go Back
          </Button>
        </div>

        {import.meta.env.DEV && error instanceof Error && (
          <details className="mt-4 rounded-md bg-gray-100 p-4 dark:bg-gray-700">
            <summary className="cursor-pointer text-sm font-medium text-gray-900 dark:text-white">
              Error Details
            </summary>
            <pre className="mt-2 whitespace-pre-wrap text-xs text-gray-600 dark:text-gray-400">
              {error.stack}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};
